module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
'use strict';

(function(fox, undefined) {
	fox.registerWidget('Autocomplete', {
		configure: function (options) {
			if (!options.input) {
				throw 'Autocomplete: No input identifier';
			}

			var inputWidget = this.inputWidget = options.inputWidget || '@parent';

			this.registerOptions('', {
				disabled: false,
				input: options.input,
				useCache: true,
				fullTrim: true,

				'widgets.updateApi': {
					widget: 'Api',
					method: options.method
				},
				'widgets.list': {
					widget: 'AdvancedList',
					autoRender: true,
				},
				'handleWom.updateApiReady': {
					widget: '#updateApi',
					event: 'ready',
					callback: 'updateApiResponse'
				},
				'handleDom': {
					inputKeyPress: {
						target: options.input,
						event: 'keypress',
						callback: 'keypress',
						targetWidget: inputWidget
					},
					inputKeyUp: {
						target: options.input,
						event: 'keyup',
						callback: 'keyup',
						targetWidget: inputWidget
					},
					inputFocus: {
						target: options.input,
						event: 'focus',
						callback: 'focus',
						targetWidget: inputWidget
					},
					inputBlur: {
						target: options.input,
						event: 'blur',
						callback: 'blur',
						targetWidget: inputWidget
					}
				},
				'handleWom.parentAddedToDom': {
					widget: inputWidget,
					event: 'addedToDom',
					callback: function () {
						this._input = this.rwom1(this.inputWidget).dom1(this.getOption('input'));
					}.bind(this)
				},
				'handleWom.listAddedToDom': {
					event: 'addedToDom',
					widget: '#list',
					callback: function (params, list) {
						this._container = list.element[0];
					}.bind(this)
				}
			});
			this.callParent('configure', arguments);
		},

		init: function() {
			this.KEY_RETURN = 13;

			this.registerOptions('#list', {
				'embed.container': this.getOption('container'),
				'embed.widget': this.inputWidget,
				'tpl.row': this.getOption('template'),
			});

			this._disabled = this.getOption('disabled');
			this._handlers = {};
			this._buffer = [];
			this._items = [];
			
			return this.callParent('init', arguments);
		},

		running: function () {
			this.list = this.rwom1('#list');

			return this.callParent('running', arguments);
		},
		
		enable: function() {
			this._disabled = false;
		},
		
		disable: function() {
			this._disabled = true;
			setTimeout(fox.bind(function() {
				this._hide();
			}, this), 100);
		},
		
		stopEvent: function() {
			if (event.preventDefault) {
				event.preventDefault();
			} else {
				event.returnValue = false;
			}

			if (event.stopPropagation) {
				event.stopPropagation();
			} else {
				event.cancelBubble = true;
			}
		},

		keypress: function(target, alias, performer, event) {
			if (event.keyCode === this.KEY_RETURN) {
				if (this._container.style.display !== 'none' && this._marked) {
					fox.dom.event.stop(event);
				}
			}
		},
		
		keyup: function(target, alias, performer, event) {
			var 
				_arguments = arguments,
				ipRegexp = /^(?:[0-9]{1,3}\.){3}[0-9]{1,3}$/,
				now = new Date().getTime();

			clearTimeout(this.timer);

			if (this.timestamp === undefined) {
				this.timestamp = now;
			}

			if (this._disabled || event.altKey || event.ctrlKey) {
				return;
			}

			if (this.getOption('fullTrim')) {
				this._input.value = fox.trim(this._input.value);
			} else {
				this._input.value = (this._input.value).replace(/^\s\s*/, '');
			}

			if ((now - this.timestamp) < 1000) {
				this.timer = setTimeout(fox.bind(function () {
					this.keyup.apply(this, _arguments);
				}, this), 1000);
				
				this.timestamp = now;

				return;
			}

			this.timestamp = now;

			if (ipRegexp.test(this._input.value)) {
				return this.submit({ip: this._input.value});
			}

			switch (true) {
				case event.keyCode === this.KEY_RETURN:
					fox.dom.event.stop(event);
					if (this._container.style.display !== 'none') {
						this._hide();
					}

					return this.submit({ip: this._input.value});
				
				case event.keyCode === this.KEY_ESC:
					this._hide();
					break;
			}

			if (this._input.value) {
				var value = this._input.value;
				this._show();

				if (this._emptyPattern && this._input.value.indexOf(this._emptyPattern) === 0) {
					this.clear();
					this._hide();
					return;
				}

				if (!this.getOption('useCache')) {
					this.update(value);

					return;
				}

				if (!this._buffer[this._input.value]) {
					this.rwom1('#updateApi').send({s: this._input.value, r: Math.random()});
				} else {
					this.redraw(this._buffer[this._input.value]);
				}
			} else {
				this.clear();
				this._hide();
			}
		},
		
		focus: function() {
			if (!this._disabled && this.list.getLength()) {
				this._show();
			}
		},
		
		blur: function() {
			if (!this._disabled) {
				setTimeout(fox.bind(function() {
					this._hide();
				}, this), 100);
			}
		},
		
		_show: function() {
			this.dispatchEvent('show');
			this.hookWrapper('show');
		},

		show: function(argument) {
			this._container.style.display = 'block';
		},
		
		_hide: function() {			
			this.dispatchEvent('hide');
			this.hookWrapper('hide');
		},

		hide: function (argument) {
			this._container.style.display = 'none';
		},
		
		_click: function(node) {
			this._input.value = node.getAttribute('data-value');
			this._hide();

			this.hookWrapper('click', node);
		},

		click: function (node) {
			this.submit({id: node.getAttribute('data-id')});
		},
		
		mark: function(elt, alt) {
			this.unmark();

			if (elt) {
				this._marked = fox.dom.addClass('marked', elt);
			} else if (alt) {
				this._marked = fox.dom.addClass('marked', elt);
			}
		},
		
		unmark: function() {
			if (this._marked) {
				fox.dom.removeClass('marked', this._marked);
				this._marked = false;
			}
		},
		
		clear: function() {
			this.list.resetCollection([]);
		},
		
		mouseover: function(node) {
			this.unmark();
			this.mark(node);
		},
		
		markFirst: function() {
			this.mark(this._container.firstChild);
		},
		
		markNext: function() {
			if (!this._marked) {
				this.mark(this._container.firstChild);
				return;
			}

			this.mark(this._marked.nextSibling, this._marked.parentNode.firstChild);
		},
		
		markPrev: function() {
			if (!this._marked) {
				this.mark(this._container.lastChild);
				return;
			}

			this.mark(this._marked.previousSibling, this._marked.parentNode.lastChild);
		},
		
		update: function(value) {
			clearTimeout(this.requestTimeout);
			
			var api = this.getApi('updateApi', {method: this.getOption('method')});

			this.handleEvent(api, ['prepare'], fox.bind(function(data) {
				this._apiInProgress = true;
			}, this));

			this.requestTimeout = setTimeout(function () {
				api.send({
					s: value,
					rand: Math.random()
				}, false);
			}, 300);
		},

		updateApiResponse: function(data) {
			this._buffer[this._input.value] = data;

			if (this._buffer[this._input.value].length) {
				this.redraw(this._buffer[this._input.value]);
			} else {
				this._emptyPattern = this._input.value;
				this.clear();
				this.hide();
			}
		},
		
		redraw: function(items) {
			this.clear();
			this._items = items;
			this.unmark();

			this.wait(this.list, 'addedToDom').then(this.addMouseEvents.bind(this));
			
			this.hookWrapper('draw', items);
		},

		draw: function (items) {
			this.list.resetCollection(items);
		},
		
		submit: function(data, skipClear) {
			this.dispatchEvent('submit', data);

			if (skipClear === undefined) {
				this.clear();
			}
		},

		getItems: function () {
			return this._items;
		},

		addMouseEvents: function () {
			fox.each(this._container.childNodes, fox.bind(function(node) {
				if (typeof node !== 'object') return;

				fox.dom.on('mousedown', node, fox.bind(function() {
					this._click(node);
				}, this));
			}, this));
		}
	}, 'Controller');
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-core-resource/lib/widgets/autocomplete.js
// module id = 105
// module chunks = 0